import React from 'react';
import Mousetrap from 'mousetrap';
import Select from 'react-select';
import { withRouter } from 'react-router';
import { Query } from 'react-apollo';
import { ALL_FUNDS } from '../../graphql/queries/all-funds.query';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import Popup from '../Popup/Popup';
import { quickSearchHandleChange } from '../../utils/navigation';
import { filterFundsByTicker, isBuyRestricted } from '../../utils/fund-info';
import styles from './QuickSearch.css';
import { publicOfferingFilterUtil } from '../../utils/GqlDataUtil/GqlDataUtil';

const popUpStyle = {
    borderRadius: '8px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)'
};

const stitchResults = (
    { allExchangeTradedFunds, allMutualFunds },
    compareSearch
) => {
    const filiteredETFs = publicOfferingFilterUtil(allExchangeTradedFunds);
    const filteredMFs = allMutualFunds.filter(
        (fund) =>
            !isBuyRestricted(
                fund.openToNewInvestors,
                fund.openToSubsequentInvestments
            )
    );
    /* Don't display etfs for comparision, yet - DE23282 */
    return compareSearch
        ? filterFundsByTicker(filteredMFs)
        : [
              ...filiteredETFs.map((f) => ({ ...f, etf: true })),
              ...filterFundsByTicker(filteredMFs)
          ];
};

class QuickSearch extends React.Component {
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        Mousetrap.bind(['shift+1'], (e) => {
            e.preventDefault();
            return this.props.toggle();
        });
    }

    render() {
        const { open, closeModal, compareSearch, handleChange } = this.props;
        const handleSelection = handleChange || quickSearchHandleChange;
        return (
            <React.Fragment>
                <Popup
                    open={open}
                    closeOnDocumentClick
                    closeOnEscape
                    onClose={closeModal}
                    contentStyle={popUpStyle}
                >
                    <div className="modal">
                        <div className="search-title">
                            Search by fund name or ticker:
                        </div>
                        <ErrorBoundary errorMsg="uh oh">
                            <Query query={ALL_FUNDS}>
                                {({ data }) =>
                                    Boolean(
                                        data &&
                                            (data.allMutualFunds ||
                                                data.allExchangeTradedFunds)
                                    ) && (
                                        <Select
                                            styles={{
                                                option: (
                                                    provided,
                                                    { data: { etf } }
                                                ) => ({
                                                    ...provided,
                                                    borderLeft: `6px solid ${
                                                        etf
                                                            ? '#8B57D9'
                                                            : '#05C3DE'
                                                    }`,
                                                    borderBottom:
                                                        '2px solid white'
                                                })
                                            }}
                                            onChange={(e) => handleSelection(e)}
                                            options={stitchResults(
                                                data,
                                                compareSearch
                                            )}
                                            autoFocus
                                        />
                                    )
                                }
                            </Query>
                        </ErrorBoundary>
                    </div>
                </Popup>
                <style jsx>{styles}</style>
            </React.Fragment>
        );
    }
}

export default withRouter(QuickSearch);
